export default __webpack_public_path__ + "static/media/hospweb1.1bf2b20b.png";